import { render } from "./FounderQuote.vue?vue&type=template&id=4e1446c4&scoped=true"
import script from "./FounderQuote.vue?vue&type=script&lang=js"
export * from "./FounderQuote.vue?vue&type=script&lang=js"

import "./FounderQuote.vue?vue&type=style&index=0&id=4e1446c4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1446c4"]])

export default __exports__